import styled, { css } from 'styled-components'

import * as emojiConverter from '@/utilities/client-components/utilities/emojiConverter'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

import MarkdownParser from './MarkdownParser/MarkdownProcessor'
import TextFormatter from './TextFormatters'

const StyledFactText = styled.div`
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, `factSet.${props.type}.color`)};
  font-size: ${(props: any) => themeUtilities.getFontSize(props.theme, 'default')}px;
  font-weight: ${(props: any) => themeUtilities.getFontWeight(props.theme, `factSet.${props.type}.weight`)};
  ${(props: any) =>
    props.wrap &&
    css`
      word-wrap: break-word;
    `};
`

interface FactTextProps {
  text: string
  type: 'title' | 'value'
}

function FactText(props: FactTextProps) {
  return (
    // @ts-expect-error
    <StyledFactText type={props.type}>
      {MarkdownParser(emojiConverter.toEmoji(TextFormatter(props.text)))}
    </StyledFactText>
  )
}

FactText.displayName = 'FactText'

export default FactText
